/**
 * Shared seat-arrangement overlay logic.
 *
 * An arrangement stores per-seat overrides (svgInfo) and can mark a seat as
 * `removed` (excluded from that layout). Applying the overlay produces the
 * display elements (with positions/model overridden) and the list of excluded
 * seat ids. Keeping this in one place ensures every map (admin + booking views)
 * renders the active arrangement identically.
 */

/** Build a seatId -> svgInfo map from an arrangement positions response. */
export function buildPositionMap(positions) {
    const posMap = {};
    for (const p of positions || []) {
        posMap[p.seatId] = p.svgInfo;
    }
    return posMap;
}

/**
 * @param {Array} elements base seat elements
 * @param {Object} posMap seatId -> svgInfo (override, or { removed: true })
 * @returns {{ displayElements: Array, excludedSeatIds: number[] }}
 */
export function applyArrangementOverlay(elements, posMap) {
    const displayElements = [];
    const excludedSeatIds = [];
    for (const el of elements) {
        const pos = posMap[el.id];
        if (pos?.removed === true) {
            excludedSeatIds.push(el.id);
            continue;
        }
        if (!pos) {
            displayElements.push(el);
            continue;
        }
        displayElements.push({
            ...el,
            x: pos.x ?? el.x,
            y: pos.y ?? el.y,
            rotation: pos.rotation ?? el.rotation,
            scale: pos.scale ?? el.scale,
            model: pos.model || el.model,
            svg: pos.svg || el.svg,
        });
    }
    return { displayElements, excludedSeatIds };
}
